<template>
    <div class="vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backtofaktur">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Preview Faktur Gaji</div>
                <div class="header-top--right">
                    <div class="header-item">
                    </div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page">

            <div class="p-y-16 p-x-20 w-limit">
                <div class="d-flex justify-content-between f-16">
                    <div class="f-c-midgrey">Karyawan</div>
                    <div class="f-c-black">Bani Isrofil</div>
                </div>
                <div class="d-flex m-t-12 justify-content-between f-16">
                    <div class="f-c-midgrey">Pekerjaan</div>
                    <div class="f-c-black">Kasir<span class="f-c-midgrey"> Outlet </span>Dreamwash</div>
                </div>
                <div class="d-flex m-t-12 justify-content-between f-16">
                    <div class="f-c-midgrey">Periode</div>
                    <div class="f-c-black">10 Feb 2020<span class="f-c-midgrey"> s/d </span>10 Mar 2020</div>
                </div>
            </div>

            <div class="separator"></div>

            <div class="p-x-20 p-t-16 p-d-10 w-limit">

                <!-- GAJI -->
                <div class="section-gaji">
                    <div class="f-c-16 f-bold">Gaji</div>
                    <div class="item-gaji--wrapper m-t-6">

                        <div class="item-gaji d-flex justify-content-between align-items-center">
                            <div class="item-gaji--left">
                                <div class="f-14">Gaji Pokok</div>
                                <div class="f-12 f-c-midgrey">800.000 x 1 periode</div>
                            </div>
                            <div class="item-gaji--right d-flex">
                                <div class="f-14">Rp 800.000</div>
                            </div>
                        </div>
                        <div class="item-gaji d-flex justify-content-between align-items-center">
                            <div class="item-gaji--left">
                                <div class="f-14">Uang Makan</div>
                                <div class="f-12 f-c-midgrey">10.000 x 22 kehadiran</div>
                            </div>
                            <div class="item-gaji--right d-flex">
                                <div class="f-14">Rp 220.000</div>
                            </div>
                        </div>
                        <div class="item-gaji d-flex justify-content-between align-items-center">
                            <div class="item-gaji--left">
                                <div class="f-14">Uang Absen</div>
                                <div class="f-12 f-c-midgrey">10.000 x 22 kehadiran</div>
                            </div>
                            <div class="item-gaji--right d-flex">
                                <div class="f-14">Rp 220.000</div>
                            </div>
                        </div>
                        <div class="item-gaji d-flex justify-content-between align-items-center">
                            <div class="item-gaji--left">
                                <div class="f-14">Uang Transport</div>
                                <div class="f-12 f-c-midgrey">80.000 x 10 kehadiran</div>
                            </div>
                            <div class="item-gaji--right d-flex">
                                <div class="f-14">Rp 800.000</div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- KOMISI -->
                <div class="section-komisi m-t-10">
                    <div class="separator-line-dot"></div>
                    <div class="f-c-16 f-bold m-t-16">Komisi</div>
                    <div class="item-komisi--wrapper m-t-6">

                        <div class="item-komisi d-flex justify-content-between align-items-center">
                            <div class="item-komisi--left">
                                <div class="f-14">Sales Keliling</div>
                                <div class="f-12 f-c-midgrey">5% dari 2.800.000</div>
                            </div>
                            <div class="item-komisi--right d-flex">
                                <div class="f-14">Rp 140.000</div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- TANGGUNGAN -->
                <div class="section-tanggungan m-t-10">
                    <div class="separator-line-dot"></div>
                    <div class="f-c-16 f-bold m-t-16">Tanggungan</div>
                    <div class="item-tanggungan--wrapper m-t-6">

                        <div class="item-tanggungan d-flex justify-content-between align-items-center">
                            <div class="item-tanggungan--left">
                                <div class="f-14">Kasbon bayar kos</div>
                                <div class="f-12 f-c-midgrey">Kasbon • Rp 500.000</div>
                            </div>
                            <div class="item-tanggungan--right d-flex">
                                <div class="f-14 f-c-red">(-) Rp 500.000</div>
                            </div>
                        </div>
                        <div class="item-tanggungan d-flex justify-content-between align-items-center">
                            <div class="item-tanggungan--left">
                                <div class="f-14">Ganti kas hilang</div>
                                <div class="f-12 f-c-midgrey">Potongan • Rp 50.000</div>
                            </div>
                            <div class="item-tanggungan--right d-flex">
                                <div class="f-14 f-c-red">(-) Rp 50.000</div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div class="separator-line-dot w-limit"></div>

            <div class="w-limit p-x-20 p-y-16 f-16 f-bold d-flex justify-content-between">
                <div class="">Total Gaji Bersih</div>
                <div class="">Rp 1.660.000</div>
            </div>

            <div class="separator"></div>

            <div class="w-limit p-x-20 p-y-20">
                <div class="btn smart-secondary" data-toggle="modal" data-target="#ekspor-faktur">Ekspor Faktur</div>
            </div>

        </div>

        <!-- MODAL -->
        <div class="modal fade" id="ekspor-faktur" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-head w-limit">
                        <div class="modal-head--left"></div>
                        <h5 class="f-16 f-bold">Ekspor Faktur</h5>
                        <div class="modal-head--right" data-dismiss="modal">
                            <img src="../../../assets/img/x2.svg" alt="">
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="modal-bodyy w-limit w-100">
                        <div class="item-export hov p-x-20 p-y-20 d-flex">
                            <img src="../../../assets/icons/pdf.svg" alt="">
                            <div class="m-l-20 f-16 flex-1 f-semi">Ekspor sebagai PDF</div>
                            <img src="../../../assets/icons/chevron_right_4.svg" alt="">
                        </div>
                        <div class="separator-line"></div>
                        <div class="item-export hov p-x-20 p-y-20 d-flex">
                            <img src="../../../assets/icons/excel.svg" alt="">
                            <div class="m-l-20 f-16 flex-1 f-semi">Ekspor sebagai file Excel</div>
                            <img src="../../../assets/icons/chevron_right_4.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name:'PreviewGaji',
        data(){
            return{

            }
        },
        mounted() {

        },
        methods:{
            backtofaktur(){
                this.$emit('backtofaktur')
            }
        }
    }
</script>

<style>
</style>